import { render } from "./Create.vue?vue&type=template&id=30670d2b"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=30670d2b&lang=css"

import exportComponent from "/home/darnell/Development/accounting/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__